import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { ReactComponent as SpotifyIcon } from '../../../images/new_icons/spotify-icon.svg';
import { ReactComponent as AppleIcon } from '../../../images/new_icons/apple-music-icon.svg';
import { ReactComponent as YandexIcon } from '../../../images/new_icons/ya-music-icon.svg';

const HistoryPopup = ({ isOpen, onClose, streamId, accentColor, backgroundColor }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (isOpen) {
            setLoading(true);
            setHistory([]); // Clear old items to prevent "flash" of stale data
            axios.get(`/api_track_history.php?stream=${streamId}&limit=20&_t=${Date.now()}`)
                .then(response => {
                    if (response.data && response.data.success) {
                        setHistory(response.data.data);
                    }
                    setLoading(false);
                })
                .catch(err => {
                    console.error('Error fetching history:', err);
                    setLoading(false);
                });
        }
    }, [isOpen, streamId]);

    if (!isOpen) return null;

    const getSearchUrl = (service, artist, track) => {
        const query = encodeURIComponent(`${artist} - ${track}`);
        switch (service) {
            case 'spotify':
                return `https://open.spotify.com/search/${query}`;
            case 'apple':
                return `https://music.apple.com/search?term=${query}`;
            case 'yandex':
                return `https://music.yandex.ru/search?text=${query}`;
            default:
                return '#';
        }
    };

    // Use Portal to render outside of .mobile-app stacking context
    return ReactDOM.createPortal(
        <div className="history-overlay" onClick={onClose}>
            <div className="history-container-relative">
                <button className="history-close" onClick={onClose}>
                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="black" strokeWidth="3" fill="none">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
                
                <div 
                    className="history-popup" 
                    onClick={e => e.stopPropagation()} 
                    style={{ 
                        borderColor: 'black',
                        backgroundColor: backgroundColor || '#7A6AB5' 
                    }}
                >
                    <h2 className="history-title">ИСТОРИЯ ТРЕКОВ</h2>
                    
                    <div className="history-list">
                        {loading ? (
                            <div className="history-loading">Загрузка...</div>
                        ) : history.length > 0 ? (
                            history.map((item, index) => (
                                <div key={index} className="history-item">
                                    <div className="history-time">{item.played_at_formatted || '--:--'}</div>
                                    <div className="history-info">
                                        <div className="history-artist">{item.artist}</div>
                                        <div className="history-track">{item.track}</div>
                                    </div>
                                    <div className="history-links">
                                        <a href={getSearchUrl('spotify', item.artist, item.track)} target="_blank" rel="noreferrer" className="history-link">
                                            <SpotifyIcon />
                                        </a>
                                        <a href={getSearchUrl('apple', item.artist, item.track)} target="_blank" rel="noreferrer" className="history-link">
                                            <AppleIcon />
                                        </a>
                                        <a href={getSearchUrl('yandex', item.artist, item.track)} target="_blank" rel="noreferrer" className="history-link">
                                            <YandexIcon />
                                        </a>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="history-empty">История пуста</div>
                        )}
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default HistoryPopup;
